import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes';
import 'bootbox';
import { catchError, first, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ServicesService } from './services.service';
import { EnumStatusBoleto } from './../enum/enumStatusBoleto';
import { ResponseCIP } from '../models/ResponseCIP';

@Injectable()
export class PagamentoService {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public processando = false;
  public pagamentos: Array<any> = undefined;
  public pagamento: any = {};
  public pagamentoIndividual: any = {};
  public indiceConversaoMoeda = 0.00;

  public loteBoletos: ResponseCIP[] = []
  public valotTotalBoletos = 0;
  public valotTotalBoletosPontos = 0;
  public boletosInvalidos: ResponseCIP[] = []
  public requisicoesLoteBoletosConcluidas = false;

  constructor(public http: HttpService, public router: Router, private servicesService: ServicesService) { }

  public list() {
    this.processando = true;
    this.pagamentos = undefined;

    this.http.pathRest().get('cartao/pagamento/', true).
      subscribe(
        sucesso => {
          this.pagamentos = sucesso.json();
          this.processando = false;
        },
        erro => {
          this.processando = false;
        }
      );
  }

  public validateLoteBoletos() {
    let requisicoesConcluidas = 0;
    const boletosNaoConsultados = this.loteBoletos.filter(item => !item.status);
    boletosNaoConsultados.forEach(item => {
      this.http.pathRest().get('cartao/pagamento/boleto/consulta/' + item.barcodeDetails.digitableLine, true)
        .pipe(
          first(),
          map(res => res.json()))
        .pipe(first(),
          catchError((error) => {
            item.status = 'Erro ao fazer a validação!';
            return of(null);
          }))
        .subscribe({
          next: (data) => {
            if (data) {
              Object.assign(item, data);
            }
          },
          error: (error) => {
            item.status = 'Erro ao validar pagamento!';
          },
          complete: () => {
            requisicoesConcluidas++;
            this.http.pathRest().get('cartao/current/indice/', true).subscribe(
              (success) => {
                this.indiceConversaoMoeda = success.json();

                if (requisicoesConcluidas === boletosNaoConsultados.length) {
                  this.requisicoesLoteBoletosConcluidas = true;
                  this.setValorBoletos();
                  this.checkBoletosValidosParaPagamento();
                }
              },
              (error) => {
                this.bootboxAlertComId.alerta('Erro ao buscar o indice moeda!');
                console.log(error);
              },
            )
          }
        });
    });
  }

  private setValorBoletos() {
    this.valotTotalBoletosPontos = 0
    this.valotTotalBoletos = 0

    this.loteBoletos.forEach(item => {
      item.valuePoints = this.servicesService.moedaToPontos(item.barcodeDetails.value, this.indiceConversaoMoeda)
      this.valotTotalBoletosPontos += item.valuePoints;
      this.valotTotalBoletos += item.barcodeDetails.value
    });
  }

  public checkBoletosValidosParaPagamento() {
    this.boletosInvalidos = this.loteBoletos.filter(item => item.status !== EnumStatusBoleto.NAO_PAGO)
  }

  public validatePagamentoIndividual() {
    this.processando = true;
    const that = this;
    this.http.pathRest().get('cartao/pagamento/boleto/consulta/' + this.pagamentoIndividual.barcodeDetails.digitableLine, true)
      .subscribe({
        next: (data) => {
          Object.assign(this.pagamentoIndividual, data.json());
          this.processando = false;

          this.http.pathRest().get('cartao/current/indice/', true).subscribe(
            (success) => {
              that.processando = false;
              this.indiceConversaoMoeda = success.json();
              this.setDadosPagamentoIndividual();
            },
            (error) => {
              this.bootboxAlertComId.alerta('Erro ao buscar o indice moeda!');
              that.processando = false;
            },
          )
        },
        error: (error) => {
          this.bootboxAlertComId.alerta('Erro ao validar pagamento!');
          this.processando = false;
        },
        complete: () => {
        }
      });
  }

  private setDadosPagamentoIndividual() {
    this.pagamentoIndividual.valuePoints = this.servicesService.moedaToPontos(this.pagamentoIndividual.barcodeDetails.value, this.indiceConversaoMoeda)
    this.pagamentoIndividual.observacao = 'Descrição do pagamento'
    this.pagamentoIndividual.barcodeDetails.value = this.setParseFloatToFixed(this.pagamentoIndividual.barcodeDetails.value)
    this.pagamentoIndividual.paymentInfo.originalValue = this.setParseFloatToFixed(this.pagamentoIndividual.paymentInfo.originalValue)
    this.pagamentoIndividual.paymentInfo.totalUpdatedValue = this.setParseFloatToFixed(this.pagamentoIndividual.paymentInfo.totalUpdatedValue)
    this.calculaTotais();
  }

  private setParseFloatToFixed(item: any) {
    return parseFloat(item).toFixed(2)
  }

  public validate() {
    this.processando = true;
    this.pagamentos = [];
    const that = this;

    this.http.pathRest().post('cartao/pagamento/' + this.pagamento.tipo + '/validacao/',
      { linhaDigitavel: this.pagamento.linhaDigitavel.replace(/\D+/g, '') }, true)
      .subscribe(
        sucesso => {
          this.pagamento = sucesso.json();
          this.http.pathRest().get('cartao/current/indice/', true)
            .subscribe(
              data => {
                that.indiceConversaoMoeda = data.json();
                that.processando = false;
                this.router.navigate(['/pagamentos/confirmacao']);
              }, error => {
                that.processando = false;
              });
        }, erro => {
          this.bootboxAlertComId.alerta(erro._body);
          that.processando = false;

        });
  };

  public calculaTotais() {
    this.calculaTotalMoeda();
    this.calculaTotalPontos();
  };

  public calculaTotalMoeda() {
    this.pagamentoIndividual.paymentInfo.totalUpdatedValue = this.pagamentoIndividual.paymentInfo.totalDiscountValue ?
      (parseFloat(this.pagamentoIndividual.paymentInfo.originalValue) -
        parseFloat(this.pagamentoIndividual.paymentInfo.totalDiscountValue)).toFixed(2)
      : this.pagamentoIndividual.paymentInfo.originalValue;
  };

  public calculaTotalPontos() {
    this.pagamentoIndividual.valuePoints =
      this.servicesService.moedaToPontos(parseFloat(this.pagamentoIndividual.paymentInfo.totalUpdatedValue),
        this.indiceConversaoMoeda);
  };

}



// WEBPACK FOOTER //
// ./src/app/resources/services/pagamento.service.ts